<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="person-search">
      <a-form layout="inline">
        <a-form-item class="name" label="家长名字">
          <a-input
            class="form-cell"
            type="text"
            placeholder="家长名字"
            v-model="queryParam.parentName"
          ></a-input>
        </a-form-item>

        <a-form-item class="name" label="手机号">
          <a-input
            class="form-cell"
            type="text"
            placeholder="手机号"
            v-model="queryParam.mobile"
          ></a-input>
        </a-form-item>

        <a-form-item class="name" label="学校">
          <a-select
            :showSearch="true"
            :showArrow="false"
            labelInValue
            placeholder="搜索学校"
            style="width: 200px !important"
            :filterOption="false"
            v-model="queryParam.schoolId"
            @search="fetch"
            @change="searchChange"
            :notFoundContent="fetching ? undefined : null"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option
              v-for="d in data"
              :key="d.value"
              :value="d.value"
              >{{ d.text }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchActivity()">查询</a-button>
          <a-button
            type="primary"
            @click="
              () =>
                (queryParam = {
                  parentName: '',
                  mobile: '',
                  schoolId: undefined,
                })
            "
            >重置</a-button
          >
        </a-form-item>
      </a-form>
    </div>

    <!-- 操作 -->
    <div class="person-oper"></div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="pagination"
      class="c-table"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="detail(record.id)">查看</a>
        </template>
      </span>
    </a-table>
    <a-modal
      :maskClosable="false"
      :visible="previewVisible"
      :footer="null"
      @cancel="previewVisible = false"
    >
      <img
        alt="example"
        style="width: 100%"
        :src="previewImage"
        @error="errorLoadImg"
      />
    </a-modal>
    <feedback-form-modal ref="feedbackForm"></feedback-form-modal>
  </div>
</template>
<script>
import CTable from "../../components/CTable";
import notification from "ant-design-vue/es/notification";
import feedback from "../../api/feedback";
import activity from "../../api/activity";
import FeedbackFormModal from "../feedback/FeedbackFormModal";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "学校",
    dataIndex: "schoolName",
    key: "schoolName",
    width: 250,
  },
  {
    title: "家长",
    dataIndex: "parentName",
    key: "parentName",
    width: 150,
  },
  {
    title: "学生",
    dataIndex: "studentName",
    key: "studentName",
    width: 150,
  },
  {
    title: "电话",
    dataIndex: "mobile",
    key: "mobile",
    width: 150,
  },
  {
    title: "创建时间",
    dataIndex: "gmtCreate",
    key: "gmtCreate",
    width: 250,
  },
  {
    title: "内容",
    dataIndex: "content",
    key: "content",
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    width: 100,
    scopedSlots: { customRender: "action" },
  },
];

export default {
  name: "feedbackList",
  props: ["orgType"],
  data() {
    return {
      previewVisible: false,
      previewImage: "",
      dataSource: [],
      columns,
      loading: false,
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
      },
      queryParam: {
        parentName: "",
        mobile: "",
        schoolId: undefined,
      }, //查询参数
      data: [],
      value: [],
      fetching: false,
    };
  },
  components: {
    CTable,
    FeedbackFormModal,
  },
  methods: {
    show(url) {
      this.previewImage = url;
      this.previewVisible = true;
    },
    //列表
    getFeedbackList(params) {
      this.loading = true;
      feedback.list(params).then((res) => {
        console.log("数据：", res);
        this.pagination = res.data.pagination;
        this.dataSource = res.data.list;
        this.loading = false;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      // console.log(pagination);
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.getFeedbackList({
        currentPage: pagination.current,
        pageSize: pagination.pageSize,
      });
    },
    detail(value) {
      let id = value ? value : -1;
      this.$refs.feedbackForm.init({ id });
    },
    searchActivity() {
      let params = this.queryParam;
      let parentName = params.parentName;
      let mobile = params.mobile;
      let schoolId = params.schoolId != undefined ? params.schoolId.key : "";

      let newParms = {};

      if (parentName != "") {
        newParms.parentName = parentName;
      }
      if (mobile != "") {
        newParms.mobile = mobile;
      }
      if (schoolId != "") {
        newParms.schoolId = schoolId;
      }

      newParms.currentPage = 1;
      this.getFeedbackList(newParms);
    },
    searchChange(value) {
      console.log("searchChange", value);
      Object.assign(this, {
        value,
        data: [],
        fetching: false,
      });
    },
    fetch(value) {
      console.log("fetching", value);
      this.data = [];
      this.fetching = true;
      let schoolName = value;
      activity.searchSchool({ schoolName }).then((res) => {
        const data = res.data.map((item) => ({
          text: item.schoolName,
          value: item.id + "",
        }));
        console.log(data);
        this.data = data;
        this.fetching = false;
      });
    },
  },

  created() {
    this.getFeedbackList({ currentPage: 1, pageSize: 10 });
  },
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.person-oper {
  margin: 20px 0px 30px;
}
</style>